import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useApplication = ({ activityId, coachActivityId }) => {
  const queryParams = new URLSearchParams();
  if (activityId) queryParams.append('activityId', activityId);
  if (coachActivityId) queryParams.append('coachActivityId', coachActivityId);

  const urlStr = queryParams.toString()
    ? `${getApiUrl()}/application/structure?${queryParams.toString()}`
    : null;

  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};
